module.exports = __webpack_public_path__ + "static/media/logo.bbd828fd.png";